const userRoles = [
    { code: 'admin', name: 'Admin' },
    { code: 'employee_expanded', name: 'Medewerker uitgebreid' },
    { code: 'employee', name: 'Medewerker' },
];

export default userRoles;
